import React from 'react'
import './contact.css'
import {MdOutlineMail} from 'react-icons/md'
import {SiMessenger} from 'react-icons/si'
import {FaWhatsapp} from 'react-icons/fa'
import { useRef } from 'react'; 
// import emailjs from 'emailjs-com'
import emailjs from '@emailjs/browser';

const Contact = () => {
const form = useRef();

const sendEmail = (e) => {
  e.preventDefault();

  emailjs.sendForm('service_haz8vv1', 'template_go33907', form.current, 'YRjnPqrGvvr27ltpt')
    .then((result) => {
        console.log(result.text);
    }, (error) => {
        console.log(error.text);
    });
      e.target.reset()
};
  return (
    <section id='contact'>
       <h5>Contact me </h5>
      <h2>Get in touch with me</h2>
      {/* e.target.reset() */}

      <div className="container contact__container">
        <div className="contact__options">
          <article className='contact__option'>
            <MdOutlineMail className='contact__option-icon' />
            <h4>Email</h4>
            <h5>Harunakadiri702@gmail.com</h5>
            <a href='mailto:harunakadiri702@gmail.com' target='_blank' rel="noreferrer">Send a message</a>
          </article>
          <article className='contact__option'>
            <SiMessenger className='contact__option-icon' />
            <h4>Messenger</h4>
            <h5>Callmea ReignB</h5>
            <a href='https://m.me/' target='_blank' rel="noreferrer">Send a message</a>
          </article>
          <article className='contact__option'>
            <FaWhatsapp className='contact__option-icon' />
            <h4>WhatsApp</h4>
            <h5>98456789</h5>
            <a href=' https://wa.me/+2347032151593' target='_blank' rel="noreferrer">Send a message</a>
          </article>
        </div>
        {/* END OF CONTACT OPTION */}
        <form ref={form} onSubmit={sendEmail}>
          <input type='text' name='user_name' placeholder='Your Full Name' required />
          <input type='email' name='user_email' placeholder='Your Email' required />
          <textarea type='message' name='message' placeholder='Your Message' required ></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact